declare let process: { env: { [key: string]: string } };
export default function getImageURL(url) {
    return (
        process.env.REACT_APP_CDN_URL + process.env.REACT_APP_ENV + "/" + url
    );
}
